import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	tickets: [],
	ticket: null,
	laundry_rooms: [],
	payment_methods: [],
	loadingSubmit: false,
	loadingTickets: false,
	loadingLaundryRooms: false,
	loadingPaymentMethods: false,
	loadingLaundryRoomMachines: false,
	laundry_room_machines: []
};

export default function ticketPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_TICKETS_PAGE_REQUEST:
		case ActionTypes.GET_TICKETS_PAGE_ERROR:
		case ActionTypes.GET_TICKETS_PAGE_SUCCESS:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_REQUEST:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_ERROR:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_SUCCESS:
		case ActionTypes.GET_PAYMENT_METHODS_REQUEST:
		case ActionTypes.GET_PAYMENT_METHODS_ERROR:
		case ActionTypes.GET_PAYMENT_METHODS_SUCCESS:
		case ActionTypes.SUBMIT_TICKET_PAGE_REQUEST:
		case ActionTypes.SUBMIT_TICKET_PAGE_ERROR:
		case ActionTypes.SUBMIT_TICKET_PAGE_SUCCESS:
		case ActionTypes.GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_REQUEST:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_ERROR:
		case ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_TICKETS_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_TICKETS_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
